<script setup lang="ts">
import { ButtonType } from '../types/common';

const { t } = useI18n();
</script>

<template>
    <VLConfirmDialog group="headless" modal class="m-6">
        <template #container="{ message, acceptCallback, rejectCallback }">
            <div class="p-dialog-header">
                <span class="font-bold text-2xl block mb-1 mt-2">{{ message.header }}</span>
            </div>
            <div class="p-dialog-content">
                <i v-if="message.icon" :class="message.icon" class="text-4xl mr-3" />
                <p class="mb-0 text-1xl">
                    {{ message.message }}
                </p>
            </div>
            <div class="p-dialog-footer">
                <div>
                    <VButton
                        v-if="message.showRejectButton !== false"
                        :label="message.rejectLabel || t('common.actions.no')"
                        class="mr-3"
                        :type="ButtonType.OUTLINE_PRIMARY"
                        @click="rejectCallback"
                    />
                    <VButton
                        :label="message.acceptLabel || t('common.actions.yes')"
                        class="mr-3"
                        :type="ButtonType.OUTLINE_SECONDARY"
                        :disabled="message.acceptDisabled"
                        @click="acceptCallback"
                    />
                </div>
            </div>
        </template>
    </VLConfirmDialog>
</template>
